export const ExpandIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.16142 5.17096V2.01313C1.16142 1.31525 1.72668 0.75 2.42457 0.75H11.2666C11.9645 0.75 12.5298 1.31525 12.5298 2.01313V10.8551C12.5298 11.5529 11.9645 12.1182 11.2666 12.1182H8.10875"
        stroke="#AEB8BE"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M0.5304 12.75L5.58301 7.69748"
        stroke="#AEB8BE"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M5.58301 12.1184V7.69748H1.16198"
        stroke="#AEB8BE"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
    </svg>
  );
};
